import type { PageCard } from '@/play/pageTypes'
import { AppleTreeCardArt } from './CardArt'

/** What the home screen shows for this page; the page itself is ./index.ts, loaded when it opens. */
export const card: PageCard = {
  id: 'apple-tree',
  number: 18,
  title: 'Apple tree',
  question: 'Gravity by material: when you hold gravity on, do big apples drop while small ones, the leaves and the branches hold?',
  status: 'open',
  accent: '#e8f2f8',
  CardArt: AppleTreeCardArt,
}
